import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { PumpsService } from 'src/app/providers/services/pumps.service';
import { Mission } from 'src/app/storage/models/mission.model';
import { Pump } from 'src/app/storage/models/pump.model';
import { SkidMission } from 'src/app/storage/models/skid-mission.model';

@Component({
    selector: 'app-add-pump',
    templateUrl: './add-pump.component.html',
    styleUrls: ['./add-pump.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddPumpComponent implements OnInit, OnDestroy {

  displayedPumps: Pump[];
  pumps: Pump[];

  @Input() mission: Mission;
  @Input() missionSkid: SkidMission;
  @Output() closeModal = new EventEmitter<any>();

  private pumpsSubscription: Subscription;

  constructor(
    private pumpsService: PumpsService
  ) { }

  ngOnInit(): void {
    this.pumpsSubscription = this.pumpsService.pumps$.subscribe((pumps: Pump[]) => {
      this.pumps = pumps;
      this.displayedPumps = this.pumps;
    });
  }

  ngOnDestroy(): void {
    if (this.pumpsSubscription) { this.pumpsSubscription.unsubscribe(); }
  }

  close(): void {
    this.closeModal.emit();
  }

  addPump(pump: Pump): void {
    this.closeModal.emit(pump);
  }

  filter($event): void {
    const value = $event.target.value;

    this.displayedPumps = this.pumps.filter(pump => {
      // List attribute to filter on
      const attributesToFilterOn = [
        pump.pumpId,
        pump.pumpName,
        pump.pumpmodelName
      ];

      // Find at least one attribute that checks the criterion
      return attributesToFilterOn.find(attribute =>
        attribute.toUpperCase().includes(value.toUpperCase())
      ) != null;
    });
  }

}
